// Content.js
import React from "react";
import Dashboard from "./Dashboard";

const Content = () => {
  return (
    <main>
      <h2>Welcome to Your Dashboard</h2>
      <Dashboard />
    </main>
  );
};

export default Content;
